import { useExperimentContext } from '../../../../contexts/session/Experiment.js';

var useImageAsset = function useImageAsset(_ref) {
  var asset = _ref.asset;
  var experiments = useExperimentContext();
  var isImage = function isImage(media) {
    return !!(media && 'image' in media);
  };
  var defaultHeightWidthValue = '48px';
  var heightNumber = parseInt(defaultHeightWidthValue, 10);
  var borderRadius = isImage(asset) ? asset.cornerRadius : undefined;
  return {
    isImage: isImage,
    defaultHeightWidthValue: defaultHeightWidthValue,
    heightNumber: heightNumber,
    borderRadius: borderRadius,
    applyOpacityToContainer: experiments.iconsMigrationToV3
  };
};

export { useImageAsset };
//# sourceMappingURL=useImageAsset.js.map
